/** Converter for Square modifier <-> Paytronix modifier. */
export class ModifierConverter {
  /**
   * Converts Square modifier to Paytronix modifier.
   * @param modifier Square modifier.
   * @param discounts Square discounts related to modifier
   * @returns Paytronix modifier.
   */
  static squareToPaytronix(modifier, discounts) {
    return {
      itemId: modifier.catalogObjectId,
      fullPrice: Number(modifier.totalPriceMoney.amount ?? 0) / 100,
      quantity: modifier.quantity,
      name: modifier.name,
      price: Number(modifier.basePriceMoney.amount ?? 0) / 100,
      referenceLine: modifier.uid,
      discounts,
    };
  }
}
